import 'primeflex/primeflex.css';

import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';

import ToggleButton from '../compiler/panels/toggleable/ToggleButton';

const CollectionGuide = () => {
  const template = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} justify-content-start border-none `;
    const titleClassName = `${options.titleClassName} ml-2`;

    return (
      <div className={className} style={{ backgroundColor: 'rgba(180, 208, 182, 0.3)' }}>
        <span className={titleClassName}>EPD Collection guide</span>
        <ToggleButton options={options} />
      </div>
    );
  };

  return (
    <Panel className="border-none mb-3" headerTemplate={template} toggleable collapsed>
      <p className="m-0">Collections help you organize published EPD documents in a hierarchical and structured manner, making them easily accessible for customers in our EPD Library.</p>
      <p>EPD Collections are available on the EPD website (<a target="_blank" rel="noopener noreferrer" href="http://www.environdec.com">www.environdec.com</a>) under the EPD Library section.</p>
      <b>How to create a collection:</b>
      <p className="m-0">1. Fill in the required information below.</p>
      <p className="m-0">
        2. Click the “Save collection” button. Once created, the collection will appear on the collections dashboard.
      </p>

      <p className="mb-0">
        <b>How to publish a collection on the EPD website:</b>
      </p>
      <p className="m-0">1. On the collection details page, click “Publish” in the top right corner.</p>
      <p className="m-0">
        2. On the collection dashboard, click the 3 dots icon on the collection card and select “Publish collection”.
      </p>

      <p className="mb-0">
        <b>How to update a collection:</b>
      </p>
      <p className="m-0">
        1. Open the collection, click the edit button, make your changes, and then click "Save collection".
      </p>
      <p className="m-0">2. To view the updated version, you need to publish it again.</p>

      <p>Please note, only <b>published</b> EPDs will be visible under the collection on the EPD website.</p>
    </Panel>
  );
};

export default CollectionGuide;
